import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faFacebook, faXTwitter } from '@fortawesome/free-brands-svg-icons';

export default function Footer() {
  const { t } = useLanguage();
  const f = t.footer;
  const productItems = t.productItems;
  const serviceItems = t.serviceItems;

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <img src={`${process.env.PUBLIC_URL}/Assets/img/logo.png`} alt="Digicorex Solutions LLC" />
          <p>{f.tagline}</p>
          <div className="footer-social">
            <a href="https://www.linkedin.com/company/digicorex-solutions/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a href="#" target="_blank" rel="noopener noreferrer" aria-label="X (Twitter)">
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </div>
        </div>
        <div className="footer-col">
          <h5>{f.productsTitle}</h5>
          <ul>
            {productItems.map(item => (
              <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h5>{f.servicesTitle}</h5>
          <ul>
            {serviceItems.map(item => (
              <li key={item.to}><Link to={item.to}>{item.label}</Link></li>
            ))}
          </ul>
        </div>
        <div className="footer-col">
          <h5>{f.companyTitle}</h5>
          <ul>
            <li><Link to="/#about">{f.aboutUs}</Link></li>
            <li><Link to="/#ezofis">{f.ezofisPlatform}</Link></li>
            <li><Link to="/#industries">{f.industriesLbl}</Link></li>
            <li><Link to="/#why">{f.whyChooseUs}</Link></li>
            <li><Link to="/contact">{f.contactUs}</Link></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div>© {new Date().getFullYear()} {f.copyrightSuffix}</div>
        <div>{f.line2}</div>
        <div>
          {f.developedBy}{' '}
          <a
            href="https://aoaix.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none' }}
          >
            Aoaix
          </a>
        </div>
      </div>
    </footer>
  );
}
